import { render, staticRenderFns } from "./xqqx.vue?vue&type=template&id=482d0390&scoped=true"
import script from "./xqqx.vue?vue&type=script&lang=js"
export * from "./xqqx.vue?vue&type=script&lang=js"
import style0 from "./xqqx.vue?vue&type=style&index=0&id=482d0390&prod&scoped=true&lang=css"
import style1 from "./xqqx.vue?vue&type=style&index=1&id=482d0390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482d0390",
  null
  
)

export default component.exports